import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { ConnectionWizardForm } from '../../containers'
import { Session } from '../../../../state/utils/session'

class ConnectionCreatorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_CONNECTIONS_PATH.replace(':client_id', this.state.session.getClientSession())}>
                        Connections
                    </NavLink>
                </li>
                <li>New Connection</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={'New Connection'}
                        subTitle={'Create a new connection'}
                        paths={this.renderHeaderPaths}
                    />
                    <ConnectionWizardForm/>
                </PageContainerLayout>
            </>
    )
  }
}

export { ConnectionCreatorPage }
